export const AUTH_TYPES = {
  LOGIN: "Login",
  REGISTER: "Register",
  FORGOT_PASSWORD: "ForgotPassword",
  RESET_PASSWORD: "ResetPassword",
}

export const AUTH_SUCCESS = {
  REGISTER: "REGISTER_SUCCESS",
  FORGOT_PASSWORD: "FORGET_PASSWORD_SUCCESS",
  RESET_PASSWORD: "RESET_PASSWORD_SUCCESS",
}

export const ADMIN_ROLE = ["SC", "SF", "AD"]
